import type * as CC from 'vanilla-cookieconsent';
import { TRACKERS, isTrackerId } from './trackers';
import type { OptionalCategory, ServiceKey } from './types';

export interface ServicePreset {
  category: OptionalCategory;
  label: string;
  /** First-party cookies this service sets; erased when the visitor rejects or withdraws. */
  cookies: CC.CookieItem[];
  onAccept?: () => void;
  onReject?: () => void;
}

/**
 * Service presets, derived from the tracker database (src/trackers.ts).
 * Third-party cookies are not listed here: a site cannot read or erase cookies of another domain.
 */
export const SERVICE_PRESETS = Object.fromEntries(
  TRACKERS.map((t) => [
    t.id,
    {
      category: t.category,
      label: t.label,
      cookies: t.cookies.filter((c) => c.firstParty).map((c) => ({ name: c.name })),
      ...(t.onAccept ? { onAccept: t.onAccept } : {}),
      ...(t.onReject ? { onReject: t.onReject } : {}),
    } satisfies ServicePreset,
  ]),
) as Record<ServiceKey, ServicePreset>;

export function isServiceKey(value: string): value is ServiceKey {
  return isTrackerId(value);
}
